import { Slot } from 'zens-router'
import { AuthLayout } from '@dms/component'

export default function Auth() {
  return (
    <AuthLayout>
      <Slot />
    </AuthLayout>
  )
}
